"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.success = exports.invalid = exports.visited = exports.current = exports.notChecked = exports.checked = exports.disabled = exports.active = exports.focus = exports.hover = void 0;
const css_1 = require("./css");
const mediaqueries_1 = require("./mediaqueries");
const hover = (...args) => (0, css_1.css) `
  @media ${mediaqueries_1.pointingDevice} {
    &:hover:not(:disabled):not([aria-disabled]) {
      ${(0, css_1.css)(...args)}
    }
  }
`;
exports.hover = hover;
const focus = (...args) => (0, css_1.css) `
  &.focus-visible:not(:disabled):not([aria-disabled]) {
    ${(0, css_1.css)(...args)}
  }
`;
exports.focus = focus;
const active = (...args) => (0, css_1.css) `
  &:active:not(:disabled):not([aria-disabled]) {
    ${(0, css_1.css)(...args)}
  }
`;
exports.active = active;
const disabled = (...args) => (0, css_1.css) `
  &[aria-disabled],
  &:disabled {
    ${(0, css_1.css)(...args)}
  }
`;
exports.disabled = disabled;
const checked = (...args) => (0, css_1.css) `
  &[aria-checked],
  &:checked {
    ${(0, css_1.css)(...args)}
  }
`;
exports.checked = checked;
const notChecked = (...args) => (0, css_1.css) `
  &:not([aria-checked]):not(:checked) {
    ${(0, css_1.css)(...args)}
  }
`;
exports.notChecked = notChecked;
const current = (...args) => (0, css_1.css) `
  &[aria-current],
  &:checked {
    ${(0, css_1.css)(...args)}
  }
`;
exports.current = current;
const visited = (...args) => (0, css_1.css) `
  &:visited {
    ${(0, css_1.css)(...args)}
  }
`;
exports.visited = visited;
const invalid = (...args) => (0, css_1.css) `
  &[aria-invalid] {
    ${(0, css_1.css)(...args)}
  }
`;
exports.invalid = invalid;
const success = (...args) => (0, css_1.css) `
  &[data-success] {
    ${(0, css_1.css)(...args)}
  }
`;
exports.success = success;
